// NotFoundPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./NotFound.module.css"; // wir nutzen externe CSS-Datei
import Footer from "../../components/Footer/Footer";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <>
    <div className={styles.notfoundContainer}>
      <div className={styles.notfoundLeft}>
        <h2>Page Not Found</h2>
        <p>Oops! The page u are looking for doesn't exist or was moved.</p>
        <button onClick={() => navigate("/")}>Return to Main Page</button>
      </div>
      <div className={styles.notfoundRight}>
        <img 
          src={`${window.location.origin}/img/notfound.jpeg`}
          alt="Not Found Illustration" 
        />
      </div>
      
    </div>
    <Footer bgColor="var(--home-bg-color)" fontColor="var(--home-font-color-primary)"/>
    </>
  );
}
